import SalesPurchaseManagement from '@containers/project/SalesPurchaseManagement';
import { useEffect } from 'react';

const SalesPurchaseManagementPage = () => {
  useEffect(() => {}, []);

  return <SalesPurchaseManagement />;
};

export default SalesPurchaseManagementPage;
